import { render } from "./MessageWrapper.vue?vue&type=template&id=455997e5&scoped=true"
import script from "./MessageWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageWrapper.vue?vue&type=script&setup=true&lang=js"

import "./MessageWrapper.vue?vue&type=style&index=0&id=455997e5&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455997e5"],['__file',"resources/js/components/whatsapp-managment/includes/types/MessageWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "455997e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('455997e5', __exports__)) {
    console.log('reload')
    api.reload('455997e5', __exports__)
  }
  
  module.hot.accept("./MessageWrapper.vue?vue&type=template&id=455997e5&scoped=true", () => {
    console.log('re-render')
    api.rerender('455997e5', render)
  })

}


export default __exports__